


















































































import { Component, Watch, Vue } from 'vue-property-decorator';
import LinkButton from '@/components/LinkButton.vue';
import VodAlertModal from '@/components/VodAlertModal.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Consumer } from '@/store/types';
import InputConsumerFields from '@/components/InputConsumerFields.vue';
import FlCheckbox from '@/components/FlCheckbox.vue';
import FlShowTac from '@/components/FlShowTac.vue';
import NoticeModal from '@/components/NoticeModal.vue';

@Component({
  components: {
    LinkButton,
    VodAlertModal,
    ValidationProvider,
    ValidationObserver,
    InputConsumerFields,
    FlCheckbox,
    FlShowTac,
    NoticeModal,
  },
})
export default class UsersAdd extends Vue {
  consumer: Consumer = {
    uuid: '',
    email: '',
    password: '',
    last_name: '',
    first_name: '',
    preferred_language: '',
    company_name: '',
    distribution_area: '',
    company_type: null,
    company_url: '',
    tel: '',
    tags: [],
    genres: [],
    areas: [],
    channels: [],
    api_token: '',
    agree_to_terms: false,
    timezone: '',
    free_word: '',
    address_country: null,
    address_fullname: null,
    address_street: null,
    address_city: null,
    address_state: null,
    address_zip: null,
    hq_country: null,
    hq_street: null,
    hq_city: null,
    hq_state: null,
    hq_zip: null,
    business_types: [],
    main_image: null,
    logo_image: null,
    annual_revenue_size: null,
    annual_revenue_currency: null,
    // preferred_currency: '',
    user_count: null,
    payment_period: null,
    payment_start_month: null,
    delivery_files: [],
    agency_fee: 0,
    management_note: null,
    admin_comment: null,
    translations: {
      ja: {
        about: null,
        pr: null,
      },
      en: {
        about: null,
        pr: null,
      },
    },
  };
  initialConsumer: any = {};
  sending: boolean = false;
  otherFieldErrors: object = {};
  phoneCountryCode: string = '';
  acceptPrivacyPolicy: boolean = false;

  get getOptionKey() {
    return function (option: any) {
      const objectKey = Object.keys(option);
      return objectKey[0];
    };
  }
  mounted() {
    // ブラウザの設定地域をデフォルトにする
    this.consumer.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.$set(this, 'initialConsumer', this.consumer);
    this.$store.dispatch('enums/getArea');
  }
  async create() {
    //reset error
    this.$set(this, 'otherFieldErrors', {});

    try {
      const validateResult = await (this as any).$refs.createForm.validate();
      console.log(validateResult);
      if (this.sending) {
        return false;
      }
      if (!validateResult) {
        const element = document.querySelector('.border-red-600:first-of-type');
        element.scrollIntoView({ behavior: 'smooth' });
        this.$modal.show('checkErrors');
        return false;
      }
    } catch (error) {
      console.log(error);
      //show modal
      this.$modal.show('failCreate');
    }

    this.sending = true;

    //prepare data
    let genres = this.formatGenres(this.consumer.genres);
    this.$set(this.consumer, 'genres', genres);
    let requestParams = Object.assign({}, this.consumer);
    requestParams.tel = this.phoneCountryCode + '_' + this.consumer.tel;

    //send data
    try {
      const result = await this.axios.post('/consumer', requestParams);
      this.sending = false;

      if (result.status === 201) {
        //goto page
        this.$set(this, 'consumer', this.initialConsumer);
        this.$router.push({ path: '/vod/register/success' });
      } else {
        //if result error, put error to show
        console.log(result);
        if (result && 'error' in result) {
          //untested
          (this as any).$refs.createForm.setErrors((result as any).error);
          this.$nextTick(() => {
            const element = document.querySelector('.border-red-600:first-of-type');
            element.scrollIntoView({ behavior: 'smooth' });
          });
        }
        //show modal
        this.$modal.show('checkErrors');
      }
    } catch (error) {
      this.sending = false;
      //look through error, put error to show
      if (error && 'response' in error && 'errors' in error.response.data) {
        (this as any).$refs.createForm.setErrors(error.response.data.errors);
        this.$nextTick(() => {
          const element = document.querySelector('.border-red-600:first-of-type');
          element.scrollIntoView({ behavior: 'smooth' });
        });
        //show modal
        this.$modal.show('checkErrors');
      } else {
        this.$modal.show('failCreate');
      }
    }
  }
  formatGenres(genres: any[]): any {
    const newGenres: string[] = [];
    genres.forEach((genre: any) => {
      newGenres.push(Object.assign({ is_main: true }, genre));
    });
    return newGenres;
  }
  setTelContryCode(contryCode: string) {
    this.$set(this, 'phoneCountryCode', contryCode);
  }
}
